import { VisiblityElement } from '@/components/snippets/visibility/visibility'

/**
 * MODAL CUSTOM ELEMENT
 * Handled as a custom element due to their being next to no state to manage, and due to how neatly it interacts with Tailwind
 *
 * For set up:
 *   1. Ensure you wrap your modal elements with <x-modal>.
 *   2. Pass a 'data-modal-id' if you want intend to nest modals.
 *   3. Provide any buttons you want to modify modal state as a child, using "data-modal-role" with open, close, or toggle.
 *   4. To show or hide elements based on modal state, set a tailwind group and use "group-data-visible:" for stateful styling.
 *
 */

class ModalElement extends VisiblityElement {
  // Child role selectors
  static OPEN_SELECTOR = '[data-modal-role~="open"]'
  static CLOSE_SELECTOR = '[data-modal-role~="close"]'
  static TOGGLE_SELECTOR = '[data-modal-role~="toggle"]'

  parseIdSelector() {
    const id = this.dataset.id
    return id ? `[data-modal-parent~="${id}"]` : ''
  }

  fetchChildren() {
    const idSelector = this.parseIdSelector()
    this.openElement = this.querySelectorAll(`${idSelector}${ModalElement.OPEN_SELECTOR}`)
    this.closeElement = this.querySelectorAll(`${idSelector}${ModalElement.CLOSE_SELECTOR}`)
    this.toggleElement = this.querySelectorAll(`${idSelector}${ModalElement.TOGGLE_SELECTOR}`)
  }

  addEventListeners() {
    super.addEventListeners()
    this.openElement?.forEach((el) => el?.addEventListener('click', this.handleShow))
    this.closeElement?.forEach((el) => el?.addEventListener('click', this.handleHide))
    this.toggleElement?.forEach((el) => el?.addEventListener('click', this.handleToggle))
  }

  removeEventListeners() {
    super.removeEventListeners()
    this.openElement?.forEach((el) => el?.addEventListener('click', this.handleShow.bind(this)))
    this.closeElement?.forEach((el) => el?.removeEventListener('click', this.handleHide.bind(this)))
    this.toggleElement?.forEach((el) => el?.removeEventListener('click', this.handleToggle.bind(this)))
  }

  connectedCallback() {
    super.connectedCallback()
    this.fetchChildren()
    this.addEventListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }
}

customElements.define('x-modal', ModalElement)
